import { ArrowPathIcon, XCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { cancelPackage } from "../../services/Esim.service";
import Button from "../ui/Button";
import IconBtn from "../ui/IconBtn";
import Modal from "../ui/Modal";

interface ICancelEsimModal {
  uniqueReservationGuid: string;
  defaultRefundAmount: number;
  onSuccess?: () => void;
}

const CancelEsimModal: React.FC<ICancelEsimModal> = ({
  uniqueReservationGuid,
  defaultRefundAmount,
  onSuccess
}) => {
  const [show, setShow] = useState(false);
  const [refundAmount, setRefundAmount] = useState<number>(defaultRefundAmount);
  const [refundInCredits, setRefundInCredits] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpen = () => {
    setRefundAmount(defaultRefundAmount);
    setRefundInCredits(false);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setRefundAmount(defaultRefundAmount);
    setRefundInCredits(false);
  };

  const handleCancel = async () => {
    setIsLoading(true);
    try {
      await cancelPackage(uniqueReservationGuid, refundAmount, refundInCredits);
      toast.success("Paketa është anuluar me sukses");
      handleClose();
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      toast.error("Ndodhi një gabim gjatë anulimit të paketës");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <IconBtn className="w-8 h-8" onClick={handleOpen}>
        <XCircleIcon className="w-8 h-8 text-red-500 hover:text-red-100" />
      </IconBtn>
      <Modal
        position="center"
        show={show}
        onClose={handleClose}
        hasHeader={false}
        calcHeight={false}
        modalWidth="380px"
        modalHeight="260px"
        buttonElement={
          <Button onClick={handleCancel} disabled={isLoading} className="flex items-center">
            {isLoading && <ArrowPathIcon className="w-4 h-4 animate-spin mr-2" />}
            Konfirmo
          </Button>
        }
      >
        <div className="flex justify-center mt-4 relative">
          <h3 className="text-lg font-semibold">Konfirmo anulimin e paketës</h3>
          <IconBtn
            className="absolute right-2 -top-2"
            onClick={handleClose}
          >
            <XMarkIcon className="w-4 h-4 text-neutral" strokeWidth={2} />
          </IconBtn>
        </div>
        <p className="justify-center w-full flex mt-2 text-gray-600 text-sm">
          Ky veprim do të anulojë paketën e rezervuar.
        </p>
        <div className="px-6 mt-3">
          <label htmlFor="refundAmount" className="block text-sm font-medium text-gray-700 mb-1">
            Shuma për rimbursim (€)
          </label>
          <input
            id="refundAmount"
            type="number"
            step="0.01"
            min="0"
            value={refundAmount}
            onChange={(e) => setRefundAmount(parseFloat(e.target.value) || 0)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none
              focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            disabled={isLoading}
          />
          <div className="flex items-center mt-3">
            <input
              id="refundInCredits"
              type="checkbox"
              checked={refundInCredits}
              onChange={(e) => setRefundInCredits(e.target.checked)}
              disabled={isLoading}
              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <label htmlFor="refundInCredits" className="ml-2 text-sm font-medium text-gray-700">
              Rimburso në kredite
            </label>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CancelEsimModal;
